var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "+_vm._s(_vm.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }